import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import ExperienceAccordion from '../../containers/experienceAccordion/ExperienceAccordion.js';
import "./Experience.css";
import { Fade } from "react-reveal";

const experience = {
	title: "Experience",
	subtitle: "Work, Internship and Volunteership",
	description:
		"I have not yet applied for any organizations. But I am open for internships in DataScience, Application and Software Development Domains. I love organising events and that is why I am also involved with many communities.",
	header_image_path: "experience.svg",
	sections: [
		{
			title: "Work Experience",
			experiences: [
				{
					title: "Backend Developer",
					company: "D'vastra",
					// company_url: "https://www.jpmorganchase.com/",
					logo_path: "d'vastra.jpeg",
					duration: "CONTRACT (Oct 2020 - Dec 2020)",
					location: "Work From Home",
					description:
						"Developed APIs and Optimised SQL queries which improved application responsiveness and reduced database costs by 20%. Added Twilio OTP support using Authy REST API for User login. Collaborated with frontend developers and software developers to implement solutions that are aligned with and extend shared platforms and solutions.",
					color: "#000000"
				}
				
			]
		},
		{
			title: "Internships",
			experiences: [
				{
					title: "Software Engineering Virtual Experience",
					company: "JP Morgan Chase & Co.",
					company_url: "https://www.jpmorganchase.com/",
					logo_path: "JPMC_logo.jpg",
					duration: "May 2020",
					location: "Work From Home",
					description:
						"Learned about software development paradigms. Was responsible for building JPMC's Perspective App from scratch and learned data manipulation, Python Programming, Web application Development (TypeScript and React).",
					color: "#000000"
				}
			]
		},
		{
			title: "Volunteerships",
			experiences: [
				{
					title: "Internshala Student Partner",
					company: "Internshala",
					company_url: "https://internshala.com/",
					logo_path: "internshala_logo.png",
					duration: "Aug 2017",
					location: "Pune, Maharashtra",
					description:
						"Internshala Student Partner is a program for university students to lead the awareness about internships and online training. Under this program, I have organised hands on workshops to teach importance of online training & MOOCs to students.",
					color: "#D83B01"
				},
				{
					title: "Coding Club Student Member",
					company: "CC GHRCEM Pune",
					logo_path: "cc_ghrcem.png",
					duration: "Jan 2018 - PRESENT",
					location: "Pune, Maharashtra",
					description:
						"We have well established coding club in college. We have organised workshops, activities and lectures on Application Development, Competitive Programming, ML & Application.",
					color: "#0C9D58"
				},
				{
					title: "Developer Program Member",
					company: "Github",
					company_url: "https://github.com/",
					logo_path: "github_logo.png",
					duration: "July 2019 - PRESENT",
					location: "Work From Home",
					description:
						"I am actively contributing to opensource projects. I have contributed to projects of organisations like mlpack, FoneAwesome , aima etc. These contributions include bug fixes, feature requests and formulating proper documentation for project.",
					color: "#181717"
				}
			]
		}
	]
};

class Experience extends Component {
	render() {
		return (
			<div className="experience-main">
				<Header />
				<div className="basic-experience">
					<Fade bottom duration={1000} distance="40px">
						<div className="experience-heading-div">
							<div className="experience-heading-img-div">
								<img
									src={require(`../../assests/images/${experience["header_image_path"]}`)}
								/>
							</div>
							<div className="experience-heading-text-div">
								<h1 className="experience-heading-text">{experience.title}</h1>
								<h3 className="experience-heading-sub-text">
									{experience["subtitle"]}
								</h3>
								<p className="experience-header-detail-text subTitle">
									{experience["description"]}
								</p>
							</div>
						</div>
					</Fade>
				</div>
				<ExperienceAccordion sections={experience["sections"]} />
				<Footer />
			</div>
		);
	}
}

export default Experience;
